import React from "react";
import classnames from "classnames";

import { ButtonTheme } from "types";

interface IconButtonProps {
  label: string; // required for a11y
  Icon: React.ComponentType<any>;
  size?: "s" | "m" | "l";
  theme?: ButtonTheme;
}

export const IconButton: React.FC<
  IconButtonProps & React.ButtonHTMLAttributes<HTMLButtonElement>
> = ({
  Icon,
  label,
  theme = ButtonTheme.primary,
  size = "m",
  className,
  disabled,
  onClick,
  ...rest
}) => {
  return (
    <button
      className={classnames(className, "icon-button", [
        size === "s" && "is-small",
        size === "l" && "is-large",
        theme === ButtonTheme.secondary && "is-secondary",
      ])}
      type="button"
      onClick={onClick}
      disabled={disabled}
      tabIndex={disabled ? -1 : 0}
      {...rest}
    >
      <span className="visually-hidden">{label}</span>
      <Icon />
    </button>
  );
};
